import React from 'react';
import { Link } from 'react-router-dom';
import LogoIcon from 'images/v5/logo.svg';
import styles from './Logo.module.scss';
function Logo() {
    return (React.createElement(Link, { to: "/", className: styles.wrap },
        React.createElement(LogoIcon, { width: "24", height: "24" })));
}
export default Logo;
